import { Component, Vue } from 'vue-property-decorator'
  import {} from '@/components/base';
  
@Component({
  components: {}
})
export default class Title1 extends Vue {

}
  